// URL to make API requests to
export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8080";
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN || "";
export const SEGMENT_KEY = process.env.REACT_APP_SEGMENT_KEY || "";
export const PRIVACY_POLICY: string = "https://www.hooper.gg/privacy-policy";

export const HOOPER_NEON_GREEN: string = "#02ff8d";
export const HOOPER_DARK_GRAY: string = "#16191a";
export const HOOPER_BLUE = "#5040FF";
export const HOOPER_LIGHT_BLUE = "#668cff";
